import React from 'react';
import TabContainer from './TabContainer';

const Drawer = () => (
    <div className="playback__columnB nocontent">
        <section className="playback__container">
            <input type="checkbox" id="playback__toggle" role="button" />
            <label htmlFor="playback__toggle" className="playback__toggle icon-font-after icon-font-after" />
            <TabContainer />
        </section>
    </div>
);

export default Drawer;



// WEBPACK FOOTER //
// ./app/drawer/Drawer.js